import React from 'react';
import {reduxForm} from 'redux-form';
import FormField from '../form/form-field';
import BaseForm from '../form/base-form';
import {validateRequiredFields} from '../../utils/form';
import Alert from '../alert';

const fields = [
    'id',
    'email',
    'password',
    'first_name',
    'last_name',
    'password',
    'password_repeat'
];

function validate(values) {
    let errors = {
        _error: null
    };
    errors = validateRequiredFields(values, [
        'first_name', 'last_name', 'email'
    ], errors);
    return errors;
}

class UserForm extends BaseForm {

    render() {
        const {
            submitting,
            error,
            handleSubmit,
            fields: {
                id,
                email,
                first_name,
                last_name,
                password,
                password_repeat
            }
        } = this.props;
        return (
            <div className="brand-form">
                <form onSubmit={handleSubmit(this.submit.bind(this))}>
                    {error && <Alert type="error">{error}</Alert>}
                    <FormField label="Email" name="email" error={email.visited && email.error} field={email}>
                        <input ref="email" className="border-full larger" placeholder="Email" type="email" {...email}/>
                    </FormField>

                    <FormField label="First name" name="first_name" error={first_name.visited && first_name.error} field={first_name}>
                        <input ref="first_name" className="border-full larger" placeholder="First name" type="text" {...first_name}/>
                    </FormField>

                    <FormField label="Last name" name="last_name" error={last_name.visited && last_name.error} field={last_name}>
                        <input ref="last_name" className="border-full larger" placeholder="Last name" type="text" {...last_name}/>
                    </FormField>

                    {!id.value ? <FormField label="Password" name="password" error={password.visited && password.error} field={password}>
                        <input ref="password" className="border-full larger" placeholder="Password" type="password" {...password}/>
                    </FormField>: null}
                    {password.value
                        ? <FormField label="Password repeat" name="password_repeat" error={password_repeat.visited && password_repeat.error} field={password_repeat}>
                                <input ref="password_repeat" className="border-full larger" placeholder="Password repeat" type="password" {...password_repeat}/>
                            </FormField>
                        : null}

                    <button type="submit" disabled={submitting}>
                        Submit
                    </button>
                </form>
            </div>
        )
    }
}

export default reduxForm({
    form: 'user',
    fields,
    validate,
    destroyOnUnmount: true
}, state => ({ // mapStateToProps
    initialValues: state.admin.users.user // will pull state into form's initialValues
}))(UserForm);



// WEBPACK FOOTER //
// ./src/js/components/user/user-form.js